import * as React from "react";
function SvgTonePositive(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M32 16A16 16 0 1116 0a16 16 0 0116 16zm-9.4 7.8a1 1 0 00-1.2-1.6c-3.63 2.72-7.17 2.72-10.8 0a1 1 0 10-1.2 1.6 11 11 0 006.6 2.46 11 11 0 006.6-2.46zM10 11a2 2 0 102 2 2 2 0 00-2-2zm12 0a2 2 0 102 2 2 2 0 00-2-2z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTonePositive);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
